module.exports = __webpack_public_path__ + "static/img/cruelty_child_2_tc.23fd5a7d.png";